import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.css']
})
export class TokenComponent extends ComponentBase implements OnInit {

  token: string = '';
  
  constructor() {
    super()
  }

  ngOnInit() {
  }

  onTokenResend() {
    let event = new AttributeModel();
    event.key = "Resend Token";
    event.type = "ActionButton";
    this.emit({ 
      name: "action",
      attribute: event
    })
  }
}
